import React, { useEffect, useRef } from "react";
import * as d3 from "d3";

const BubbleChart = ({ chartData }) => {
    const svgRef = useRef(null);

    useEffect(() => {
        const filteredData = chartData.filter((d) => d.value > 0);

        // SVG 설정
        const width = 300;
        const height = 230;

        const svg = d3
            .select(svgRef.current)
            .attr("width", width)
            .attr("height", height);

        // 반경 비율 계산 (value 값 기준)
        const maxValue = Math.max(...filteredData.map((d) => d.value));
        const radiusScale = d3.scaleLinear().domain([0, maxValue]).range([20, 60]); // 최소 20, 최대 50 크기
        const fontScale = d3.scaleLinear().domain([0, maxValue]).range([15, 20]); // 최소 20, 최대 50 크기

        const simulation = d3
            .forceSimulation(filteredData)
            .force(
                "charge",
                d3.forceManyBody().strength(-20) // 음의 값으로 설정하여 중심에 더 가까워짐
            )
            .force(
                "center",
                d3.forceCenter(width / 2, height / 2) // SVG 중심으로 위치
            )
            .force(
                "collision",
                d3.forceCollide((d) => radiusScale(d.value) / 1.3 ) // 충돌 반경
            )
            .on("tick", () => {
                // 원이 SVG 영역을 벗어나지 않도록 좌표 제한
                circles
                    .attr("cx", (d) => Math.max(radiusScale(d.value), Math.min(width - radiusScale(d.value), d.x)))
                    .attr("cy", (d) => Math.max(radiusScale(d.value), Math.min(height - radiusScale(d.value), d.y)));

                // 텍스트 업데이트
                labels
                    .attr("x", (d) => Math.max(radiusScale(d.value), Math.min(width - radiusScale(d.value), d.x)))
                    .attr("y", (d) => Math.max(radiusScale(d.value), Math.min(height - radiusScale(d.value), d.y)))
                    .each(function (d) {
                        const textElement = d3.select(this);

                        // 첫 번째 줄 업데이트
                        textElement.select("tspan.name")
                            .attr("x",  Math.max(radiusScale(d.value), Math.min(width - radiusScale(d.value), d.x)))
                            .attr("dy", `-${radiusScale(d.value) / 4}px`);

                        // 두 번째 줄 업데이트
                        textElement.select("tspan.value")
                            .attr("x",  Math.max(radiusScale(d.value), Math.min(width - radiusScale(d.value), d.x)))
                            .attr("dy", `${radiusScale(d.value) / 2}px`);

                        // 세 번째 줄 업데이트
                        textElement.select("tspan.unit")
                    });
            });

        // 원 생성
        const circles = svg
            .selectAll("circle")
            .data(filteredData)
            .enter()
            .append("circle")
            .attr("cx", (d) => Math.max(radiusScale(d.value), Math.min(width - radiusScale(d.value), d.x)))
            .attr("cy", (d) => Math.max(radiusScale(d.value), Math.min(height - radiusScale(d.value), d.y)))
            .attr("r", (d) => radiusScale(d.value)) // 반경 비율 적용
            .attr("fill", (d) => d.circleColor)

        // 텍스트 추가
        const labels = svg
            .selectAll("text")
            .data(filteredData)
            .enter()
            .append("text")
            .attr("text-anchor", "middle") // 텍스트를 가로로 중앙 정렬
            .attr("dominant-baseline", "middle") // 텍스트를 세로로 중앙 정렬
            .style("font-size", (d) => `${radiusScale(d.value) / 4}px`); // 반경에 비례한 텍스트 크기


        labels.each(function (d) {
            const textElement = d3.select(this);
            // 첫 번째 줄: d.name
            textElement
                .append("tspan")
                .attr("class", "name")
                .text(d.name)
                .attr("fill", (d) => d.color) // 글씨 색상
                .style("font-size", `${fontScale(d.value)*0.8}px`) // 원하는 크기
                .style("font-family", "Inter") // 폰트 설정
                .style("font-weight", "bold"); // 굵게 설정

            // 두 번째 줄: d.value + "명"
            textElement
                .append("tspan")
                .attr("class", "value")
                .text(`${d.value}`)
                .attr("fill", (d) => d.color)
                .style("font-size", `${fontScale(d.value)*1.2}px`)
                .style("font-family", "Inter")
                .style("font-weight", "bold");

            textElement
                .append("tspan")
                .attr("class", "unit")
                .text("명")

                .attr("x", null)
                .attr("dy", "2px")
                .attr("fill", (d) => d.color)
                .style("font-size", `${fontScale(d.value)*0.7}px`)
                .style("font-family", "Inter")
                .style("font-weight", "bold");
        });


        return () => {
            simulation.stop(); // 컴포넌트 언마운트 시 시뮬레이션 중지
        };
    }, []); // chartData가 변경될 때만 실행

    return <svg ref={svgRef}></svg>;
};

export default BubbleChart;
